import React, { Suspense } from "react";
import { Toaster } from "sonner";
import { AppRouter } from "@/features/routes/AppRouter";
import { AppProviders } from "@/app/providers";
import { LoadingPage } from "@/components";

export const App: React.FC = () => {
  return (
    <AppProviders>
      <Suspense fallback={<LoadingPage />}>
        <AppRouter />
      </Suspense>
      <Toaster richColors position="top-right" />
    </AppProviders>
  );
};

export default App;
